import React from 'react';

const SlowSpinner = () => {
    return (<i className="fas fa-sync-alt fa-spin" />);
};

export default SlowSpinner;
